import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ReportTemplateCreateRequest, ReportTemplatePatchInBatchRequest, ReportTemplateResponse } from '@/api/services/configuration/report-templates/report-templates.dto'

class ReportTemplateService {
    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>('/configuration/reportTemplates', { params: request })
        return response.data
    }

    async get(reportTemplateId: number): Promise<ReportTemplateResponse> {
        const response = await axios.get<ReportTemplateResponse>(`/configuration/reportTemplates/${reportTemplateId}`)
        return response.data
    }

    async patch(request: ReportTemplatePatchInBatchRequest): Promise<ReportTemplateResponse> {
        const response = await axios.get<ReportTemplateResponse>('/configuration/reportTemplates', { params: request })
        return response.data
    }

    async post(request: ReportTemplateCreateRequest): Promise<ReportTemplateResponse> {
        const response = await axios.get<ReportTemplateResponse>('/configuration/reportTemplates', { params: request })
        return response.data
    }

    async getList(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined): Promise<IResponseAgGrid<ReportTemplateResponse>> {
        const response = await axios.put<IResponseAgGrid<ReportTemplateResponse>>('/configuration/reportTemplates', { ...filterModel }, { params })
        return response.data
    }
}
export const reportTemplateService = new ReportTemplateService()
